import React from "react";

class RainstormIcon extends React.Component {
  render() {
    return (
    <svg
        width="50"
        height="50"
        viewBox="0 0 24 24"
        fill="#00acc1"
        >
        <path d="M17.92 7.02C17.45 4.18 14.97 2 12 2 9.82 2 7.83 3.18 6.78 5.06 4.09 5.41 2 7.74 2 10.5 2 13.53 4.47 16 7.5 16h10c2.48 0 4.5-2.02 4.5-4.5 0-2.34-1.79-4.27-4.08-4.48M14.8 17l-2.9 3.32 2 1L11.55 24h2.65l2.9-3.32-2-1L17.45 17zm-6 0-2.9 3.32 2 1L5.55 24H8.2l2.9-3.32-2-1L11.45 17z"></path>
        <path d="M0 0h24v24H0z" fill="none" />
    </svg>);
  }
}
export default RainstormIcon;
